<app-help-page mainVideo="real-time-notifications"
               [tutorials]="['real-time-notifications']"
               [videos]="['ga-real-time-notifications']"></app-help-page>
